<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sdk`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 4a2 2 0 012 2v36a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h40zm-2 4H6v32h36V8zm-17.335 5.01l1.775.197a1 1 0 01.884 1.105l-.003.025-2.57 18.794a1 1 0 01-1.102.858l-1.774-.197a1 1 0 01-.88-1.129l2.57-18.794a1 1 0 011.1-.858zm-7.576 4.95l1.254 1.164a1 1 0 01.035 1.432l-3.45 3.528 3.45 3.528a1 1 0 01-.016 1.414l-.019.018-1.254 1.164a1 1 0 01-1.39-.028l-5.356-5.391a1 1 0 010-1.41l5.356-5.391a1 1 0 011.39-.028zm15.212.028l5.356 5.391a1 1 0 010 1.41l-5.356 5.39a1 1 0 01-1.39.03l-1.254-1.165a1 1 0 01-.035-1.432l3.45-3.528-3.45-3.528a1 1 0 01.035-1.432l1.254-1.164a1 1 0 011.39.028z"/></svg>
</template>
<script>

export default {
  name: 'IconSdk',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
